import { FormType } from './form';

export const ParentObjTypes = [
  FormType.SERVICE,
  FormType.PROJECT,
  FormType.SIMPLETASK,
  FormType.SOURCELIST,
  FormType.PRODUCTION,
];
export const ActiveColumnEnabledTypes = [FormType.ITEM];
